export  const TipoTemaEnum = {   
    NORMA_PRAZO_FERIADO: {text:"Norma de Prazo e Feriado",value:"Norma de Prazo e Feriado"},
}
export default TipoTemaEnum;

